module.exports = __webpack_public_path__ + "assets/images/grid/covid-hits-home-14.jpg?v=dd9cf573";